import React, {useEffect} from "react";
import {MenuItem} from "@mui/material";
import CustomTextField from "../../customMUIComponents/CustomTextField";
import Box from "@mui/material/Box";
import {useLocation} from "react-router-dom";
import {RateEnum} from "../../../enums/RateEnum";
import Typography from "@mui/material/Typography";

export interface SubscriptionSelectionDataProps {
    subscriptionChoice: string,
    setSubscriptionChoice: (subscriptionChoice: string) => void,
}

const subscriptionsMenuItemOptions = [
    {
        rateEnum: RateEnum.STARTER,
        textLong: 'Starter: 9.90CHF/mois, 8% par transaction (min. 0.50CHF)',
        textShort: 'Starter: 9.90CHF/mois',
    },
    {
        rateEnum: RateEnum.PRO,
        textLong: 'Pro: 29.90CHF/mois, 6% par transaction (min. 0.50CHF)',
        textShort: 'Pro: 29.90CHF/mois',
    },
    {
        rateEnum: RateEnum.BUSINESS,
        textLong: 'Business: 49.90CHF/mois, 4% par transaction (min. 0.50CHF)',
        textShort: 'Business: 49.90CHF/mois',
    },
]

const RATE_TO_FEE_TEXT_MAP: { [key in RateEnum]: string } = {
    [RateEnum.STARTER]: 'Frais de transaction Starter: 8% par transaction (min. 0.50CHF)',
    [RateEnum.PRO]: 'Frais de transaction Pro: 6% par transaction (min. 0.50CHF)',
    [RateEnum.BUSINESS]: 'Frais de transaction Réservation: 4% par transaction (min. 0.50CHF)',
};

const SubscriptionSelection = ({subscriptionChoice, setSubscriptionChoice}: SubscriptionSelectionDataProps) => {

    const {hash} = useLocation();

    const hashIsPresent: boolean = !!hash && hash.length > 0;

    const rateEnum: string = hashIsPresent ? hash.substring(1, hash.length).toUpperCase() : '';

    const rateEnumExists = Object.values(RateEnum).includes(rateEnum.toUpperCase() as RateEnum);

    useEffect(() => {
        if (rateEnumExists) {
            setSubscriptionChoice(rateEnum);
        }
    }, [rateEnumExists, rateEnum, setSubscriptionChoice]);

    return (
        <>
            <Box
                sx={{
                    display: {xs: 'none', sm: 'block'}
                }}
            >
                <CustomTextField
                    variant={"outlined"}
                    value={subscriptionChoice}
                    label={"Type d'abonnement"}
                    setField={(fieldValue) => setSubscriptionChoice(fieldValue)}
                    select
                    selectOptions={
                        subscriptionsMenuItemOptions.map((subscriptionsMenuItemOption) => {
                            return (
                                <MenuItem
                                    key={subscriptionsMenuItemOption.rateEnum}
                                    value={subscriptionsMenuItemOption.rateEnum}
                                >
                                    {subscriptionsMenuItemOption.textLong}
                                </MenuItem>
                            )
                        })
                    }
                    mb={4}
                    textAlign={"left"}
                    required
                />
            </Box>
            <Box
                sx={{
                    display: {xs: 'block', sm: 'none'}
                }}
            >
                <CustomTextField
                    variant={"outlined"}
                    value={subscriptionChoice}
                    label={"Type d'abonnement"}
                    setField={(fieldValue) => setSubscriptionChoice(fieldValue)}
                    select
                    selectOptions={subscriptionsMenuItemOptions.map((subscriptionsMenuItemOption) => {
                            return (
                                <MenuItem
                                    key={subscriptionsMenuItemOption.rateEnum}
                                    value={subscriptionsMenuItemOption.rateEnum}
                                >
                                    {subscriptionsMenuItemOption.textShort}
                                </MenuItem>
                            )
                        }
                    )}
                    mb={4}
                    textAlign={"left"}
                    required
                />

                {subscriptionChoice && (
                    <Typography
                        variant={"secondVariant"}
                        fontSize={"16px"}
                        textAlign={"left"}
                        mb={4}
                    >
                        {RATE_TO_FEE_TEXT_MAP[subscriptionChoice as RateEnum]}
                    </Typography>
                )}

            </Box>
        </>
    );
}

export default SubscriptionSelection
